import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ArrowLeft, Sparkles } from 'lucide-react';
import { useProject } from '../../context/ProjectContext';
import { apiClient } from '../../services/apiService';
import { getMenuItems } from '../../constants/moduleMenuMapping';

const Sidebar = () => {
  const location = useLocation();
  const { project, projectId } = useProject();
  const [menuItems, setMenuItems] = useState(() => getMenuItems([]));

  useEffect(() => {
    if (!projectId) return;
    apiClient.get(`/api/projects/${projectId}/modules`)
      .then(res => {
        const modules = res.data?.enabled || res.data?.data?.enabled || [];
        setMenuItems(getMenuItems(modules));
      })
      .catch(() => {
        // Fallback: show defaults (dashboard, media, settings)
      });
  }, [projectId]);

  const basePath = `/p/${projectId}`;

  const isActive = (route) => {
    const fullPath = `${basePath}/${route}`;
    if (route === 'dashboard') return location.pathname === fullPath;
    return location.pathname.startsWith(fullPath);
  };

  return (
    <div className="hidden lg:flex lg:w-64 lg:flex-col lg:fixed lg:inset-y-0 z-50">
      <div className="flex flex-col flex-grow bg-white border-r border-slate-200 overflow-y-auto">
        {/* Logo */}
        <div className="flex-shrink-0 flex items-center justify-center py-5 border-b border-slate-200">
          <a href="https://dexcy.in" target="_blank" rel="noopener noreferrer">
            <img
              src="/dexcy-cms-logo.png"
              alt="Dexcy CMS"
              className="h-8 object-contain"
            />
          </a>
          <Sparkles className="w-6 h-6 text-blue-600 hidden" />
        </div>

        {/* Back to Projects */}
        <div className="px-4 py-2">
          <Link to="/" className="flex items-center gap-2 px-4 py-2 text-xs font-medium text-slate-400 hover:text-blue-600 transition-colors">
            <ArrowLeft className="w-3.5 h-3.5" />
            All Projects
          </Link>
        </div>

        {/* Dynamic Navigation */}
        <nav className="flex-1 px-3 py-2 space-y-0">
          {menuItems.map((item) => {
            const Icon = item.icon;
            const active = isActive(item.route);
            return (
              <Link
                key={item.key}
                to={`${basePath}/${item.route}`}
                className={`
                  flex items-center gap-3 px-4 py-2 text-sm font-medium rounded-md transition-colors
                  ${active
                    ? 'bg-blue-50 text-blue-600 border-l-3 border-blue-600 font-semibold'
                    : 'text-slate-600 hover:text-slate-900 hover:bg-slate-100'
                  }
                `}
              >
                <Icon className={`w-4 h-4 flex-shrink-0 ${active ? 'text-blue-600' : 'text-slate-400'}`} />
                <span>{item.name}</span>
              </Link>
            );
          })}
        </nav>

        {/* Footer */}
        <div className="flex-shrink-0 border-t border-slate-200 px-4 py-3">
          <a href="https://dexcy.in" target="_blank" rel="noopener noreferrer" className="text-xs text-slate-400 hover:text-slate-600">Dexcy CMS</a>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
